import { Observable } from 'rxjs';
import { DocumentViewModel } from '../../viewModels/documents/documentViewModel';
import { UploadViewModel } from '../../viewModels/documents/uploadViewModel';
import { ObjectTypes } from '../../enums/objectTypes';
import { ChecklistDocumentViewModel } from '../../models/checklists/checklistAttachmentsViewModel';
import { DocumentCategoryViewModel } from '../../viewModels/documents/documentCategoryViewModel';

/**
 * Abstraction for document operations
 * Supports both normal and external user flows
 */
export abstract class DocumentAbstraction {
  abstract addDocument(uploadViewModel: UploadViewModel, externalShareId?: string): Observable<DocumentViewModel>;

  abstract updateDocument(uploadViewModel: UploadViewModel): Observable<DocumentViewModel>;

  abstract deleteDocument(documentId: number, globalObjectId: number, globalObjectType: number): Observable<void>;

  abstract getByObjectId(objectId: number, objectType: ObjectTypes, externalShareId?: string): Observable<DocumentViewModel[]>;

  abstract uploadFile(file: File, isAttachment?: boolean, isAccountLogo?: boolean): Observable<string>;

  abstract uploadPart(part: number, originalFileName: string, file: File, externalShareId?: string): Observable<void>;

  abstract completeUpload(originalFileName: string, newFileName: string, isAttachment: boolean, isAccountLogo: boolean): Observable<string>;

  abstract deleteUnassignedFile(fileName: string): Observable<void>;

  abstract getObjectChecklistDocuments(objectId: number, objectType: ObjectTypes): Observable<ChecklistDocumentViewModel[]>;

  abstract downloadDocument(id: number): void;

  abstract splitUploadFile(file: File, compress?: boolean, isAttachment?: boolean, isAccountLogo?: boolean, externalShareId?: string): Observable<string>;

  abstract getDocumentCategoriesWithDocuments(externalShareId?: string): Observable<DocumentCategoryViewModel[]>;
}
